// extracted by mini-css-extract-plugin
module.exports = {"WhoWeAre":"WhoWeAre_WhoWeAre__srs_K","WhoWeAre__title":"WhoWeAre_WhoWeAre__title__UVJ5O","WhoWeAre__description":"WhoWeAre_WhoWeAre__description__GEbqe"};